import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Breadcrumb } from '@markant-platform/shared/breadcrumb/feature';

@Injectable({
  providedIn: 'root',
})
export class CartridgeMembersOverviewBreadcrumbResolver {
  resolve(route: ActivatedRouteSnapshot): Breadcrumb[] {
    const cartridgeId = route.paramMap.get('cartridgeId') as string;
    return [
      {
        label: '',
        url: `${cartridgeId}/employees`,
        translateLabel: 'dashboardOverview.navigation.serviceMembers.label',
      },
    ];
  }
}
